export default "__VITE_ASSET__wbd2Bd0G__"